module.exports = __webpack_public_path__ + "img/psstruck-nobg.8329ede8.png";